import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const SliderH = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 11.0002H17.8C17.3 9.40019 15.6 8.60019 14 9.20019C13.1 9.50019 12.5 10.2002 12.2 11.0002H3C2.4 11.0002 2 11.4002 2 12.0002C2 12.6002 2.4 13.0002 3 13.0002H12.2C12.7 14.6002 14.4 15.4002 16 14.8002C16.9 14.5002 17.5 13.8002 17.8 13.0002H21C21.6 13.0002 22 12.6002 22 12.0002C22 11.4002 21.6 11.0002 21 11.0002ZM15 13.0002C14.4 13.0002 14 12.6002 14 12.0002C14 11.4002 14.4 11.0002 15 11.0002C15.6 11.0002 16 11.4002 16 12.0002C16 12.6002 15.6 13.0002 15 13.0002Z"
      fill="currentColor"
    />
  </svg>
)

export default SliderH
